module.exports = __webpack_public_path__ + "static/media/icons_Bilan g‚n‚ral.db5b1863.svg";